// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc863a09","396":"893f29da","455":"f6455f5f","977":"bd9ef7ba"}[chunkId] + ".chunk.js";
};